<div class="userhistoryDialogue">
  <div class="dialog-header">
    <span class="dialog-label">Project Change Log: {{label}}</span>
  </div>
  <div class="custom_small_panelbody_fix">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 mat-table-custom">
      <ng-container matColumnDef="projectTitle">
        <th mat-header-cell *matHeaderCellDef>Project Title</th>
        <td mat-cell *matCellDef="let row">{{row.projectTitle}}</td>
      </ng-container>
      <ng-container matColumnDef="responsibleUser">
        <th mat-header-cell *matHeaderCellDef>Point of Contact</th>
        <td mat-cell *matCellDef="let row">{{row.responsibleUser}}</td>
      </ng-container>
      <ng-container matColumnDef="multiproject">
        <th mat-header-cell *matHeaderCellDef>Multiproject</th>
        <td mat-cell *matCellDef="let row">{{getMultiprojectLabel(row.multiprojectId)}}</td>
      </ng-container>
      <ng-container matColumnDef="investmentType">
        <th mat-header-cell *matHeaderCellDef>Investment Type</th>
        <td mat-cell *matCellDef="let row">{{getInvestmentTypeLabel(row.investmentTypeId)}}</td>
      </ng-container>
      <ng-container matColumnDef="informationTechnology">
        <th mat-header-cell *matHeaderCellDef>IT</th>
        <td mat-cell *matCellDef="let row">{{row.informationTechnology ? 'YES' : 'NO'}}</td>
      </ng-container>
      <ng-container matColumnDef="manufacturing">
        <th mat-header-cell *matHeaderCellDef>MFG</th>
        <td mat-cell *matCellDef="let row">{{row.manufacturing ? 'YES' : 'NO'}}</td>
      </ng-container>
      <ng-container matColumnDef="fieldOperations">
        <th mat-header-cell *matHeaderCellDef>FLD</th>
        <td mat-cell *matCellDef="let row">{{row.fieldOperations ? 'YES' : 'NO'}}</td>
      </ng-container>
      <ng-container matColumnDef="researchDevelopment">
        <th mat-header-cell *matHeaderCellDef>R&D</th>
        <td mat-cell *matCellDef="let row">{{row.researchDevelopment ? 'YES' : 'NO'}}</td>
      </ng-container>
      <ng-container matColumnDef="bigR">
        <th mat-header-cell *matHeaderCellDef>BigR</th>
        <td mat-cell *matCellDef="let row">{{row.bigR ? 'YES' : 'NO'}}</td>
      </ng-container>
      <ng-container matColumnDef="maintenance">
        <th mat-header-cell *matHeaderCellDef>Maintenance %</th>
        <td mat-cell *matCellDef="let row">{{row.maintenance}}</td>
      </ng-container>
      <ng-container matColumnDef="expansion">
        <th mat-header-cell *matHeaderCellDef>Expansion %</th>
        <td mat-cell *matCellDef="let row">{{row.expansion}}</td>
      </ng-container>
      <ng-container matColumnDef="focus">
        <th mat-header-cell *matHeaderCellDef>Focus</th>
        <td mat-cell *matCellDef="let row">{{row.focus ? 'YES' : 'NO'}}</td>
      </ng-container>
      <ng-container matColumnDef="phaseId">
        <th mat-header-cell *matHeaderCellDef>Phase</th>
        <td mat-cell *matCellDef="let row">{{getPhaseLabel(row.phaseId)}}</td>
      </ng-container>
      <ng-container matColumnDef="updatedBy">
        <th mat-header-cell *matHeaderCellDef>Modified By</th>
        <td mat-cell *matCellDef="let row">{{row.updatedBy}}</td>
      </ng-container>
      <ng-container matColumnDef="updatedAtUtc">
        <th mat-header-cell *matHeaderCellDef>UTC Date</th>
        <td mat-cell *matCellDef="let row">{{ row.updatedAtUtc | date:'yyyy-MM-dd HH:mm' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    </table>
  </div>
  <div class="dialog-actions">
    <button mat-button class="btn" (click)="close()">Back</button>
  </div>
</div>
